export * from 'utils/assets';

// TODO: remove youtube:id support
/** Matches YouTube single video urls and youtube:id format */
//   (based on https://gist.github.com/rodrigoborgesdeoliveira/987683cfbfcc8d800192da1e73adc486 - ignoring oembed and attribution_link urls for now)
const youtubeVideoRegex = /^youtube:([0-9a-z_-]+)$|(?:youtube(?:-nocookie)?\.com\/(?:watch.*[?&]v=|(?:v|embed|watch|shorts|live|e)\/)|youtu\.be\/)([0-9a-z_-]+)(?:[?&#]|$)/i;

/** Matches YouTube playlist urls */
const youtubePlaylistRegex = /(?:youtube(?:-nocookie)?\.com\/|youtu\.be\/).*[?&]list=([0-9a-zA-Z_-]+)(?:[?&#]|$)/i;

/** Matches basic video file extensions */
const videoFileRegex = /\.(mp4|webm|mov)$/i;

/** Extracts YouTube video ID from full youtube URL or youtube:id */
export function getYoutubeId(url) {
	if (!url || typeof url !== 'string') return null;
	const match = url.match(youtubeVideoRegex);
	return match?.slice(1).find(Boolean) || null;
}
/** Extracts YouTube playlist ID from full youtube URL */
export function getYoutubePlaylistId(url) {
	if (!url || typeof url !== 'string') return null;
	const match = url.match(youtubePlaylistRegex);
	return match?.[1] || null;
}

export function isYoutubeVideo(url) {
	return !!getYoutubeId(url);
}
export function isYoutubePlaylist(url) {
	return !!getYoutubePlaylistId(url);
}
/** Returns true if the URL is a YouTube video or playlist */
export function isYoutubeLink(url) {
	return isYoutubeVideo(url) || isYoutubePlaylist(url);
}

/** Returns true if the URL is a supported video file (e.g. mp4, webm) */
export function isVideoFile(url) {
	return videoFileRegex.test(url);
}
/** Returns true if the URL is any supported video asset (e.g. video file, youtube video, ...) */
export function isVideoAsset(url) {
	return isVideoFile(url) || isYoutubeLink(url);
}
